var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmationTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.6199 14.3502C74.382 5.08237 62.0647 0 49 0C35.9054 0 23.5882 5.08237 14.3502 14.3502C5.08237 23.5882 0 35.9054 0 49C0 62.0946 5.08237 74.3819 14.3502 83.6498C23.5882 92.8877 35.9054 98 49 98C62.0946 98 74.3819 92.9176 83.6498 83.6498C92.8877 74.4118 98 62.0946 98 49C97.9701 35.9054 92.8877 23.5882 83.6199 14.3502Z",
    fill: "#BE8E5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5591 57.6618L33.0485 48.1912C31.2173 46.3676 28.2046 46.3676 26.3734 48.1912C24.5422 50.0147 24.5422 53.0147 26.3734 54.8382L39.2215 67.6324C41.0527 69.4559 44.0654 69.4559 45.8966 67.6324L72.6266 41.0147C74.4578 39.1912 74.4578 36.1912 72.6266 34.3676C70.7954 32.5441 67.7827 32.5441 65.9515 34.3676L42.5591 57.6618Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationTick);
export default __webpack_public_path__ + "static/media/confirmation_tick.d492790a5894070acfb6545aa3b3dc4b.svg";
export { ForwardRef as ReactComponent };